import appConfig from 'appConfig';
import { dispatch } from 'pluginServices/store';
import { pushToast } from 'containers/ToastManager/actions';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import publicationService from 'services/PublicationService';
import { getElementTocLevel } from 'Workspace/Cohorts/components/CohortDeploymentsList/BronteViewer/mediaImportData';
import { sortByDate } from 'Workspace/Publications/utils';
import messages from '../messages';

const showToastError = (message) => {
  dispatch(pushToast({ message: intl.formatMessage(message) }));
};

export const generateLearnspaceUrl = async (publicationItem) => {
  const { activityId, outputType, market } = publicationItem;

  const { publications } = await publicationService.getPublicationHistory(activityId, outputType, market);

  if (!publications?.length) {
    return showToastError(messages.noPublicationHistory);
  }
  const sortedPublications = sortByDate(publications);
  const { cohortId, deploymentId, description } = sortedPublications[0];

  if (!cohortId || !deploymentId) {
    return showToastError(messages.invalidLearnspaceUrlOption);
  }

  const publicationDetails = JSON.parse(description);

  const tocLevelValue = getElementTocLevel(publicationDetails?.tocLevel);
  const tocLevel = tocLevelValue ? `?tocLevel=${tocLevelValue}` : '';
  const learnspaceUrl = `${appConfig.getLearnspaceURL()}/learn/${cohortId}/${deploymentId}${tocLevel}`;
  return learnspaceUrl;
};